/** 视口壳层：同步顶栏实测高度与可视视口高度（含浏览器缩放） */

export const HEADER_SELECTOR = '.site-header'
export const DEFAULT_HEADER_OFFSET = 80

let headerObserver = null
let teardownViewportShell = null

/** 当前可视视口高度（优先 visualViewport，兼容浏览器缩放） */
export function getViewportHeight() {
  if (typeof window === 'undefined') return 900
  return window.visualViewport?.height ?? window.innerHeight
}

/** 读取 CSS 变量 --header-offset（px） */
export function getHeaderOffset() {
  if (typeof document === 'undefined') return DEFAULT_HEADER_OFFSET

  const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-offset')
  const parsed = parseFloat(raw)
  if (Number.isFinite(parsed) && parsed > 0) return parsed

  return DEFAULT_HEADER_OFFSET
}

function syncHeaderOffset() {
  if (typeof document === 'undefined') return

  const header = document.querySelector(HEADER_SELECTOR)
  if (!header) return

  const height = Math.ceil(header.getBoundingClientRect().height)
  if (height > 0) {
    document.documentElement.style.setProperty('--header-offset', `${height}px`)
  }
}

function syncAppVh() {
  if (typeof document === 'undefined') return
  document.documentElement.style.setProperty('--app-vh-px', `${Math.round(getViewportHeight())}px`)
}

function syncViewportShell() {
  syncHeaderOffset()
  syncAppVh()
}

/** 挂载视口壳层同步；返回 teardown 函数 */
export function initViewportShell() {
  if (typeof window === 'undefined') return () => {}

  if (teardownViewportShell) {
    teardownViewportShell()
    teardownViewportShell = null
  }

  syncViewportShell()

  const header = document.querySelector(HEADER_SELECTOR)
  if (header && typeof ResizeObserver !== 'undefined') {
    headerObserver = new ResizeObserver(() => syncHeaderOffset())
    headerObserver.observe(header)
  }

  const onViewportChange = () => syncViewportShell()
  window.addEventListener('resize', onViewportChange)

  const visualViewport = window.visualViewport
  if (visualViewport) {
    visualViewport.addEventListener('resize', onViewportChange)
    visualViewport.addEventListener('scroll', onViewportChange)
  }

  teardownViewportShell = () => {
    window.removeEventListener('resize', onViewportChange)
    if (visualViewport) {
      visualViewport.removeEventListener('resize', onViewportChange)
      visualViewport.removeEventListener('scroll', onViewportChange)
    }
    if (headerObserver) {
      headerObserver.disconnect()
      headerObserver = null
    }
    teardownViewportShell = null
  }

  return teardownViewportShell
}
